// extracted by mini-css-extract-plugin
export default {"pageContentWrapper":"generate-favr-rates_pageContentWrapper__kzw5w","headerWrapper":"generate-favr-rates_headerWrapper__Tb7Do"};